import { Component, Inject, OnInit, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { ToastrService } from 'ngx-toastr';
import { Message } from 'src/app/core/class/message';
import { CommonService } from 'src/app/core/services/common.service';
import { ServiceTypeService } from 'src/app/core/services/service-type.service';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';

@Component({
  selector: 'app-config-document-group',
  templateUrl: './config-document-group.component.html',
  styleUrls: ['./config-document-group.component.scss']
})
export class ConfigDocumentGroupComponent implements OnInit {
  isReadySignEkyc: boolean;
  isReadySignAdvancedEkyc: boolean;

  tplModal: NzModalRef;
  serviceType: any;
  // isCheckSignEkyc: boolean = false;
  // isCheckSignEkycAdvanced: boolean = false;
  isDisableEkyc: boolean = false;
  isDisableEkycAdvanced: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<ConfigDocumentGroupComponent>,
    @Inject(MAT_DIALOG_DATA) public dataInput: any,
    private serviceTypeService: ServiceTypeService,
    public commonService: CommonService,
    private message: Message,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private modalService: NzModalService
  ) { 
    dialogRef.disableClose = false;
  }

  ngOnInit() {
    this.serviceType = this.dataInput.serviceType;
    this.isReadySignEkyc = this.dataInput.isReadySignEkyc;
    this.isReadySignAdvancedEkyc = this.dataInput.isReadySignEkycAdvanced;
    // if (this.isReadySignEkyc && this.serviceType.ekycSupportConfig === 1) this.isCheckSignEkyc = true;
    // if (this.isReadySignAdvancedEkyc && this.serviceType.ekycSupportConfig === 2) this.isCheckSignEkycAdvanced = true;
    this.getIsDisabledEkyc(this.dataInput.quantityEkycInfo)
  }

  getIsDisabledEkyc(quantityEkycInfo: any): void {
    if (!quantityEkycInfo.isBoughtEkyc) {
      this.isDisableEkyc = true;
    }  
    // else if (!(quantityEkycInfo.ekycQuantity >= 0)) this.isDisableEkyc = true;

    if (!quantityEkycInfo.isBoughtEkycAdvanced) {
      this.isDisableEkycAdvanced = true;
    } 
    // else if (!(quantityEkycInfo.advanceEkycQuantity >= 0)) this.isDisableEkycAdvanced = true;
  }
  onCloseDialog() {
    this.dialogRef.close()
  }

  onAllowCheckSign(document: any, isAllowCheck: boolean, type: string) {
    let dataDialog;
    if (type === 'allowOtp') {
      dataDialog = this.commonService.format(this.message.getMessage(isAllowCheck
        ? 'messages.confirm_off_sign_otp_type' : 'messages.confirm_on_sign_otp_type'), document.name);
    }
    if (type === 'allowImage') {
      dataDialog = this.commonService.format(this.message.getMessage(isAllowCheck
        ? 'messages.confirm_off_sign_image_type' : 'messages.confirm_on_sign_image_type'), document.name);
    }
    if (type === 'checkCertNumber') {
      dataDialog = this.commonService.format(this.message.getMessage(isAllowCheck
        ? 'messages.confirm_off_check_cts_type' : 'messages.confirm_on_check_cts_type'), document.name);
    }
    if (type === 'checkName') {
      dataDialog = this.commonService.format(this.message.getMessage(isAllowCheck
        ? 'messages.confirm_off_check_name_type' : 'messages.confirm_on_check_name_type'), document.name);
    }
    if (type === 'checkOtp') {
      dataDialog = this.commonService.format(this.message.getMessage(isAllowCheck
        ? 'messages.confirm_off_check_otp_type' : 'messages.confirm_on_check_otp_type'), document.name);
    }

    // EKYC & EKYC advanced
    if (type === "allowEkyc") {
      dataDialog = this.commonService.format(this.message.getMessage(
        document.allowAdvancedEkyc ? 'messages.confirm_on_sign_ekyc_and_of_ekyc_advanced' : 
        (isAllowCheck ? 'messages.confirm_off_sign_ekyc' : 'messages.confirm_on_sign_ekyc')), document.name);
    }

    if (type === 'allowAdvancedEkyc') {
      dataDialog = this.commonService.format(this.message.getMessage(
        document.allowEkyc ? 'messages.confirm_on_sign_ekyc_advanced_and_of_ekyc' :
        (isAllowCheck ? 'messages.confirm_off_sign_ekyc_advanced' : 'messages.confirm_on_sign_ekyc_advanced')), document.name);
    }

    // EKyc bổ trợ ký otp và ký ảnh
    if (type === 'supportEkyc') {
      dataDialog = this.commonService.format(this.message.getMessage(
        document.ekycSupportConfig === 2 ? 'messages.confirm_on_ekyc_and_of_ekyc_advanced_add-on' :
        (isAllowCheck ? 'messages.confirm_off_ekyc_add-on' : 'messages.confirm_on_ekyc_add-on')), document.name);
    }

    if (type === 'supportEkycAdvanced') {
      dataDialog = this.commonService.format(this.message.getMessage(
        document.ekycSupportConfig === 1 ? 'messages.confirm_on_ekyc_advanced_and_of_ekyc_add-on' :
        (isAllowCheck ? 'messages.confirm_off_ekyc_advanced_add-on' : 'messages.confirm_on_ekyc_advanced_add-on')), document.name);
    }

    const dialogRef = this.dialog.open(WarningComponent, {
      width: '350px',
      data: dataDialog
    });
    dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        if (type === 'allowOtp') {
          document.allowOtp = !document.allowOtp;
          if((document.allowOtp === false) && (document.allowImage === false)) {
            document.checkEkycSupport = false;
            document.ekycSupportConfig = 0;
          }
        }
        if (type === 'allowImage') {
          document.allowImage = !document.allowImage;
          if((document.allowOtp === false) && (document.allowImage === false)) {
            document.checkEkycSupport = false;
            document.ekycSupportConfig = 0;
          }
        }
        if (type === 'checkCertNumber') {
          document.checkCertNumber = !document.checkCertNumber;
        }
        if (type === 'checkName') {
          document.checkName = !document.checkName;
        }
        if (type === 'checkOtp') {
          document.checkOtp = !document.checkOtp;
        }

        // EKYC && EKYC Advanced
        if (type === 'allowEkyc') {
          document.allowEkyc = !document.allowEkyc;
          if (document.allowAdvancedEkyc) {
            document.allowAdvancedEkyc = false;
          }
        }
        if (type === 'allowAdvancedEkyc') {
          document.allowAdvancedEkyc = !document.allowAdvancedEkyc;
          if (document.allowEkyc) {
            document.allowEkyc = false;
          }
        }

        // Bổ trợ EKYC và EKYC Nâng cao cho ký OTP và Ký điện tử
        if (type === 'supportEkyc') {
          if (document.ekycSupportConfig === 1) {
            // document.checkEkycSupport = false;
            document.ekycSupportConfig = 0;
          } else {
            // document.checkEkycSupport = true;
            document.ekycSupportConfig = 1;
          }

          // this.isCheckSignEkyc = !this.isCheckSignEkyc;
          // if (this.isCheckSignEkyc) {this.isCheckSignEkycAdvanced = false;}
        }
        if (type === 'supportEkycAdvanced') {
          if (document.ekycSupportConfig === 2) {
            // document.checkEkycSupport = false;
            document.ekycSupportConfig = 0;
          } else {
            // document.checkEkycSupport = true;
            document.ekycSupportConfig = 2;
          }
          // this.isCheckSignEkycAdvanced = !this.isCheckSignEkycAdvanced
          // if (this.isCheckSignEkycAdvanced) {this.isCheckSignEkyc = false;}
        }
        this.serviceTypeService.updateServiceTypes(document, (err) => {
        }).subscribe((res) => {
          if (res.success) {
            this.toastr.success(this.message.getMessage('messages.update_success'));
          } else {
            this.toastr.error(res.message);
          }
        });
      }
    });
  }

  createTplModal(tplTitle: TemplateRef<{}>, tplContent: TemplateRef<{}>, tplFooter: TemplateRef<{}>): void {
    this.tplModal = this.modalService.create({
      nzTitle: tplTitle,
      nzContent: tplContent,
      nzFooter: tplFooter,
      nzMaskClosable: true,
      nzClosable: true,
      nzOnOk: () => console.log('Click ok')
    });
  }

  destroyTplModal(): void {
    setTimeout(() => {
      this.tplModal.destroy();
    }, 300);
  }

}
